export default __webpack_public_path__ + "static/media/window_decal.d121c10b.png";